import env from 'enviro';
import { stringify } from 'hub-http/helpers/params';
import { SignupQueryKeys } from 'signup-constants/SignupQueryKeys';
import { SignupUrlGenerator } from 'signup-ui-url-generator/SignupUrlGenerator';
import { getQueryParams } from './queryParams';
export const getHubsSignupUrl = () => {
  const baseUrl = `${window.location.hostname}${window.location.pathname}`;
  const url = encodeURI(baseUrl.split('?')[0]);
  return url;
};
const getSavedQueryParams = (queryParams, paramsToSave) => {
  const savedQueryParams = {};
  const defaultParamsToSave = '^hubs_|^utm_';
  const expression = paramsToSave && paramsToSave.length ? `${defaultParamsToSave}|${paramsToSave.join('|')}` : defaultParamsToSave;
  const re = new RegExp(expression);
  Object.keys(queryParams).forEach(param => {
    const match = param.match(re);
    if (match && !(param === 'hubs_signup-url' || param === 'hubs_signup-cta')) {
      savedQueryParams[param] = queryParams[param];
    }
  });
  return savedQueryParams;
};
const stringifyQueryParams = queryParams => {
  const filtered = Object.fromEntries(Object.entries(queryParams).filter(([__key, value]) => value));
  return stringify(filtered);
};
const getIsQAProxy = () => window.location.hostname.indexOf('wthubspot') >= 0;
export const formatPublicExperimentationForQueryParams = treatments => {
  if (!(treatments !== null && treatments !== void 0 && treatments.length)) return undefined;
  const params = new URLSearchParams();
  treatments.forEach(treatment => {
    params.append('external-experiment-parameter', `${treatment.treatmentKey}-group-${treatment.group}`);
  });
  return params.toString();
};
const createSignupQuery = signupIntent => {
  if (!signupIntent) return {};
  return {
    [SignupQueryKeys.Intent]: signupIntent
  };
};
const cleanUpQueryParams = queryParams => {
  const queryParamsMap = {
    currency: queryParams.currencyCode,
    'hubs_signup-url': queryParams.hubsSignupUrl,
    'hubs_signup-cta': queryParams.hubsSignupCta,
    dtbId: queryParams.dtbId,
    dtb_source: queryParams.dtbSource,
    experimentKey: queryParams.experimentKey,
    experimentParameter: queryParams.experimentParameter,
    uuid: queryParams.uuid,
    flags: queryParams.flags,
    isHsoc: queryParams.isHsoc
  };
  Object.keys(queryParamsMap).forEach(key => {
    if (queryParamsMap[key] === undefined || queryParamsMap[key] === null) {
      delete queryParamsMap[key];
      return;
    }
    if (Array.isArray(queryParamsMap[key])) {
      return;
    }
    if (typeof queryParamsMap[key] !== 'string') {
      queryParamsMap[key] = `${queryParamsMap[key]}`;
    }
  });
  return queryParamsMap;
};
export const generateSignupUrlWithQueryParams = ({
  signupType,
  signupIntent,
  queryParams,
  additionalQueryParams = {},
  experiments
}) => {
  const defaultSavedQueryParams = getSavedQueryParams(getQueryParams());
  const queryParamsMap = cleanUpQueryParams(queryParams);
  const stringifiedQueryParams = stringifyQueryParams(Object.assign({}, additionalQueryParams, defaultSavedQueryParams, queryParamsMap));
  const experimentParamString = formatPublicExperimentationForQueryParams(experiments);
  const signupQuery = createSignupQuery(signupIntent);
  const baseUrl = new SignupUrlGenerator(signupType, {
    query: signupQuery,
    env: env.isQa() || getIsQAProxy() ? 'qa' : 'prod'
  }).getUrl();
  const initialQueryParamPunctuation = signupIntent ? '&' : '?';
  return `${baseUrl}${initialQueryParamPunctuation}${stringifiedQueryParams}${experimentParamString ? `&${experimentParamString}` : ''}`;
};